var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
export var SidebarListItem = function (props) {
    return (_jsx(Link, __assign({ to: props.path }, { children: _jsx("div", __assign({ className: twMerge('tracking-tigh flex cursor-pointer bg-transparent py-[14px] pl-[60px] font-sans text-sm font-normal leading-5 text-[#6F7276]', props.currentPath === props.path
                ? 'border-r-[2px] border-solid border-primary bg-[#EDF2FA] text-primary'
                : '') }, { children: props.label })) })));
};
